import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { SessionService }  from './session.service';
import { SmsApiSessionService }  from './sms-api-session.service';
import { AgreementService } from './agreement.service';

import { AppSettings } from '../app.settings';
import { writeAuthPackage } from './auth-token';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
    public username: string;

  constructor(private http: HttpClient, private sessionService: SessionService, private smsApiSessionService: SmsApiSessionService, private agreementService: AgreementService) {

  	this.smsApiSessionService.getSession().then(user => {
  		this.username = user.username;
  	}).catch(error => {
  		console.log(error);
  		this.username = "USER NOT SET";
  	});

  }

    login(username: string, password: string): Promise<boolean | string> {

        return new Promise((resolve, reject) => {
        //	this.http.post(AppSettings.API_ENDPOINT + 'login', JSON.stringify({ username: username, password: password }), AppSettings.DEFAULT_HTTP_OPTIONS)
          this.http.post(AppSettings.NEW_API_ENDPOINT + "users/login", JSON.stringify({ username: username, password: password }), AppSettings.DEFAULT_HTTP_OPTIONS)
            .subscribe((response: any) => {

                // login successful if there's a jwt token in the response
            //    if(response.data && response.type=='auth_object'){
                  if(response.data && response.data.type=='auth_object'){
                	console.log(response);

                    let token = response.data.token;

                        // store username and jwt token in local storage to keep user logged in between page refreshes
                        writeAuthPackage({ username: username, token: token });

                        this.username = username;

                        this.sessionService.setUser(response.data.user);

                        // return true to indicate successful login
                         resolve(true);

                } else {
                    reject(response);
                }
            }, error_response => {
              if(error_response instanceof HttpErrorResponse){
                // The /users/login endpoint returns 401/403 with an empty body
                // on bad credentials. Translate that to a useful message here
                // so the UI doesn't fall back to "An unknown error occurred".
                if (error_response.status === 401 || error_response.status === 403) {
                  reject('Username or password is incorrect. Please try again.');
                  return;
                }
                if (error_response.status === 0) {
                  reject('We couldn\'t reach the login service. Check your connection and try again.');
                  return;
                }
                reject(error_response.error || error_response);
              } else {
                  reject(error_response);
              }
          });
        });
	}

  adopt_user_login(username: string, password: string, their_username: string, their_email: string): Promise<boolean | string> {
    return new Promise((resolve, reject) => {
          this.http.post(AppSettings.API_ENDPOINT + 'admin/adopt_user_login', JSON.stringify({ username: username, password: password, their_username: their_username, their_email: their_email }), AppSettings.DEFAULT_HTTP_OPTIONS)
            .subscribe((response: any) => {

                // login successful if there's a jwt token in the response
                if(response.data && response.type=='auth_object'){

                  console.log(response);

                    let token = response.data.token;

                        // Store the ADOPTED user's name, not the admin's - this used
                        // to save `username` (the admin doing the adopting) against
                        // the target's token, so the header showed the wrong person.
                        // `adopted` tells SmsApiSessionService to validate this token
                        // against the legacy API, which is what minted it.
                        writeAuthPackage({
                          username: their_username,
                          token: token,
                          adopted: true,
                          adopted_by: username
                        });

                        this.username = their_username;

                        this.sessionService.setUser(response.data.user);

                        // return true to indicate successful login
                         resolve(true);

                } else {
                    reject(response);
                }
            }, error_response => {
              if(error_response instanceof HttpErrorResponse){
                reject(error_response.error);
              } else {
                  reject(error_response);
              }
          });
        });
  }

  logout(): Promise<any> {
    return new Promise((resolve, reject) => {

      try {
        localStorage.removeItem(AppSettings.AUTH_TOKEN_NAME);

        this.sessionService.setUser(null);
        this.agreementService.clearCache();

        resolve("User is logged out.");

      } catch ( error ) {
        reject(error);
      }

    });
  }


}
